module.exports = __webpack_public_path__ + "static/media/slide_3.277c4ccc.jpg";